import {useLayoutEffect} from 'react'

function usePipelinesPages() {
  /*
   * Fix: PopupTarget wrapper popups position fixing inside
   * the #main-content-tag [position: relative] container
   */
  useLayoutEffect(() => {
    const parentContainer = document.getElementById('main-content-tag')

    if (parentContainer != null) {
      parentContainer.style.position = 'static'
    }
  }, [])
}

export default usePipelinesPages
